import { render, staticRenderFns } from "./SplitScreenDialog.vue?vue&type=template&id=a3c681ac&scoped=true&"
import script from "./SplitScreenDialog.vue?vue&type=script&lang=js&"
export * from "./SplitScreenDialog.vue?vue&type=script&lang=js&"
import style0 from "./SplitScreenDialog.vue?vue&type=style&index=0&id=a3c681ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c681ac",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VImg,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src904045295/src/ueyes-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3c681ac')) {
      api.createRecord('a3c681ac', component.options)
    } else {
      api.reload('a3c681ac', component.options)
    }
    module.hot.accept("./SplitScreenDialog.vue?vue&type=template&id=a3c681ac&scoped=true&", function () {
      api.rerender('a3c681ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/SplitScreenDialog.vue"
export default component.exports